<template>
  <div class="sso_view row align-items-center">
    <div class="col-sm-4"></div>
    <div class="col-sm-4">
      <div class="panel panel-default border shadow sso_panel">
        <div class="panel-body">
          <table>
            <tr></tr>
            <tr>
              <td>
                <img
                  alt="TSWCD Logo"
                  src="/img/tualatin-soilandwater-logomark-color-multicolor.png"/>
              </td>
            </tr>
            <tr>
              <td>
                You are not authorized to use Acorn.
              </td>
            </tr>
            <tr>
              <td>
                <button
                  type="button"
                  class="btn border rounded"
                  @click="signIn"
                >Sign In</button>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div class="col-sm-4"></div>
  </div>
</template>

<script>
export default {
  mounted() {
    // if we are authenticated, give it one more shot to see if we can get in
    if (this.$msal.isAuthenticated) {
      this.$msal.signIn(this.$router);
    }
  },
  methods: {
    signIn() {
      this.$msal.signIn(this.$router);
    },
  },
};
</script>
